import { type CostHistoryResponse, CostHistoryResponseSchema } from '../data/cost-history';
import { normalizeProduct, type Product, ProductSchema } from '../data/product';
import { createMultipleHandler, createSingleHandler } from '../helpers/fetch-wrapper';
import { storesBaseUrl as baseUrl, StoreScopedService } from './base';

export class ProductService extends StoreScopedService {
  getProductsByStore(storeId: string): Promise<Product[]> {
    return this.fetchWrapper
      .get(`${baseUrl}/${storeId}/products`)
      .then(createMultipleHandler(ProductSchema))
      .then((products: Product[]) => products.map(normalizeProduct));
  }

  updateProduct(storeId: string, product: Product): Promise<Product> {
    return this.fetchWrapper
      .put(`${baseUrl}/${storeId}/vendors/${product.vendor_id}/products/${product.id}`, product)
      .then(createSingleHandler(ProductSchema));
  }

  getProductCostHistory(
    storeId: string,
    vendorId: string,
    productId: string
  ): Promise<CostHistoryResponse> {
    return this.fetchWrapper
      .get(`${baseUrl}/${storeId}/vendors/${vendorId}/products/${productId}/cost-history`)
      .then(createSingleHandler(CostHistoryResponseSchema));
  }
}
